import type {ReactAction} from '@netx/core/bootstrap';
import {faArrowDownToBracket} from '@netx/core-icons';
import {type ICategory} from '@netx/core-category-next/schema';
import {canDownloadCategory} from '../enablers';
import {CategoryActionLabel} from '../locales';
import {CATEGORY_EVENT} from './constants';

export const categoryActionDownloadIcon = faArrowDownToBracket;

/**
 * Download category assets
 * @param params
 * @returns Action
 */
export const categoryActionDownload = (
	category?: ICategory,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'category-download',
	cb: () => dispatcher.trigger(CATEGORY_EVENT.DOWNLOAD, category),
	enableTest: () => canDownloadCategory(category),
	icon: categoryActionDownloadIcon,
	get label() {
		return CategoryActionLabel.DOWNLOAD;
	},
	...params,
});

export default categoryActionDownload;
